export const GET_SUPPORT_TOTAL_UNREAD_COUNT = 'GET_SUPPORT_TOTAL_UNREAD_COUNT'
export const SELECTED_SUPPORT_CHAT = 'SELECTED_SUPPORT_CHAT'
